import React from "react";
import { slide as Menu } from "react-burger-menu";
import './sidebar.css';
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default function Sidebar(){
  return (
    // Pass on our props
    <Menu width={300}>
      <AnchorLink className="menu-item" href='#top'>Home</AnchorLink>
	  <AnchorLink className="sub-menu-item" href='#basics'>Basics Of Fat Loss</AnchorLink>
	  <AnchorLink className="sub-menu-item" href='#diet'>Diet for Fat Loss</AnchorLink>
	  <AnchorLink className="sub-menu-item" href='#workout'>Workout for Fat Loss</AnchorLink>
	  <AnchorLink className="sub-menu-item" href='#mistakes'>Mistakes which hinders Progress</AnchorLink>
	  <AnchorLink className="sub-menu-item" href='#myths'>Myths to avoid</AnchorLink>

    </Menu>
  );
};
